import { HiOutlineCheck } from "react-icons/hi2";

type Props = {
  icon?: React.ReactNode;
  feature?: number | string | React.ReactNode;
  text?: string | React.ReactNode;
  children?: React.ReactNode;
};

const SubscriptionItemFeature = ({ icon, feature, text, children }: Props) => {
  return (
    <div className="flex items-center gap-2 py-1.5">
      <div className="aspect-square rounded-full bg-success-primary p-1.5 text-success">
        {icon ?? <HiOutlineCheck className="size-3 stroke-[3px]" />}
      </div>
      {children ?? (
        <div className="text-sm text-secondary">
          {feature && <span className="font-semibold">{feature}</span>}
          {text && <span className={"ml-1"}>{text}</span>}
        </div>
      )}
    </div>
  );
};

export default SubscriptionItemFeature;
